import React, { Component } from 'react';
import {SmallUnderline} from "../../styles/components/SmallUnderline";
import { Link } from "../link/Link";
import { Row, Col } from 'reactstrap';
import {BasicAnimation} from "../animations/BasicAnimation";

export class NewsListCard extends Component {

  render() {
    return (
      <Link to={"/news/" + this.props.slug} tag={"a"}>
        <BasicAnimation duration={400} delay={0}>
        <div className={ this.props.className + " newscard news-list-card m-3" }>
          <Row className="contact-item">
            <Col xs="12" md="4" lg="3">
              <div className="newscard-bg-img card-img-top"
                   style={{ backgroundImage: 'url(' + ( this.props.image || require('../../assets/images/no-image.png') ) + ')'}}/>
            </Col>
            <Col xs="12" md="8" lg="9">
              <div className="news-type">/ { typeof this.props.type === 'string' ? this.props.type : "News" }</div>
              <SmallUnderline align="left">
                <h4>{ typeof this.props.title === 'string' ? this.props.title : "" }</h4>
              </SmallUnderline>
              <p className={"news-date"}>{ typeof this.props.date === 'string' ? this.props.date : "" }</p>

              <div className="news-card-body"
                dangerouslySetInnerHTML={{
                __html:  typeof this.props.content === 'string' ? this.props.content : ""
                }}/>
            </Col>
          </Row>
        </div>
        </BasicAnimation>
      </Link>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/item/NewsListCard.js